import { useCallback, useEffect, useState } from 'react';
import { useApiFetch } from './useApiFetch';

export interface SampleMeta {
  location: string;
  filename: string;
  eval_set_id: string;
  epoch: number;
  id: string;
  uuid: string;
}

export const useSampleMeta = (sampleUuid?: string) => {
  const [sampleMeta, setSampleMeta] = useState<SampleMeta | null>(null);
  const { apiFetch, isLoading, error } = useApiFetch();

  const getSampleMeta = useCallback(
    async (uuid: string) => {
      const sampleMetaUrl = `/meta/samples/${encodeURIComponent(uuid)}`;
      const response = await apiFetch(sampleMetaUrl);
      if (!response) {
        throw new Error('Failed to fetch sample metadata');
      }
      const data = (await response.json()) as SampleMeta;
      return data;
    },
    [apiFetch]
  );

  useEffect(() => {
    if (!sampleUuid) return;

    const fetchSampleMeta = async () => {
      const data = await getSampleMeta(sampleUuid);
      setSampleMeta(data);
    };

    fetchSampleMeta();
  }, [sampleUuid, getSampleMeta]);

  return { sampleMeta, isLoading, error };
};
